

/**
 * 状态选项
 */
export const statusOptions = [
  { label: '开启', value: 1 },
  { label: '关闭', value: 2 },
]

// 系统配置类型
export const systemConfigOptions = [
  { label: 'OpenAiKey配置', value: 'OpenAiKey' },
  { label: '请求地址', value: 'StableDiffusionUrl' },
  { label: '绘图预角色提示词', value: 'PreDrawRolePrompt' },
  { label: '绘图GPT案例', value: 'DrawPromptExample' },
  { label: '默认正向提示词', value: 'DefaultPrompt' },
  { label: '默认反向提示词', value: 'DefaultPromptNegativePrompt' },
  { label: 'AI女友默认配置', value: 'aiChatBaseConfig' },
]

/**
 * 聊天类型选项
 */
export const chatTypeOptions = [
  { label: '文本补全', value: 'textCompletion' },
  { label: '聊天补全', value: 'chatCompletion' },
]
// GeminiModelType   ModelType = "gemini"   // Gemini模型
// QwqModelType      ModelType = "qwq"      // 千问模型
// GrokModelType     ModelType = "grok"     // Grok模型
// DeepSeekModelType ModelType = "deepSeek" // DeepSeek模型
/**
 * 模型系列
 */
export const modelTypeOptions = [
  { label: 'Gemini模型', value: 'gemini' },
  { label: '千问模型', value: 'qwq' },
  { label: 'Grok模型', value: 'grok' },
  { label: 'DeepSeek模型', value: 'deepSeek' },
]
